import Vue from 'vue';
import VueRouter from 'vue-router';

import { pageState } from '@helpers/page-state';

import Login from '@components/Auth/Login.vue';
import UserAgents from '@components/UserAgents/UserAgents.vue';
import UserChat from '@components/UserChat/UserChat.vue';
import UserProfile from '@components/UserProfile/UserProfile.vue';
import E404 from '@components/partials/error/E404.vue';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject); }
    return originalPush.call(this, location).catch((err) => {
        if (VueRouter.isNavigationFailure(err)) {
            // resolve err
            return err;
        }
        // rethrow error
        return Promise.reject(err);
    });
};

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/profile',
        name: 'profile',
        component: UserProfile,
    },
    {
        path: '/chat/:conversationSid?',
        name: 'chat',
        component: UserChat,
    },
    {
        path: '/agents/chat/:agentUuid/:conversationSid?',
        name: 'agentChat',
        component: UserChat,
    },
    {
        path: '/agents/:active',
        name: 'agents',
        component: UserAgents,
    },
    {
        path: '*',
        name: '404',
        component: E404,
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

const isAuthenticated = pageState && pageState.isAuthUser;
const canHandleAgents = pageState && pageState.canHandleAgents;
const redirectUrl = (pageState && pageState.redirectUrl) || '/';

router.beforeEach((to, from, next) => {
    if (['profile', 'chat', 'agents', 'agentChat'].includes(to.name) && !isAuthenticated) {
        next({ path: '/login', query: { redirectUrl } });
    } else if (to.name === 'agents' && !canHandleAgents) {
        next({ path: '/404' });
    } else next();
});

export default router;
